import { render, staticRenderFns } from "./addplatform.vue?vue&type=template&id=5b994fc2&"
import script from "./addplatform.vue?vue&type=script&lang=js&"
export * from "./addplatform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b994fc2')) {
      api.createRecord('5b994fc2', component.options)
    } else {
      api.reload('5b994fc2', component.options)
    }
    module.hot.accept("./addplatform.vue?vue&type=template&id=5b994fc2&", function () {
      api.rerender('5b994fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/components/addplatform.vue"
export default component.exports